<template>
  <div>
    <div v-if="!isMobile">
      <table v-if="sticky" class="sticky">
        <thead>
          <tr>
            <th rowspan="2" class="border-R"
              v-bind:style="{ width: dimension.tableSAG + 'px' }">Service Area Geofences</th>
            <th :colspan="webforms.length"
              v-bind:style="{ width: dimension.tableWN + 'px' }">Webform Name</th>
          </tr>
          <tr>
            <th v-for="(webform, index) in webforms" v-bind:style="{ width: dimension.webForms['tableWF' + index] + 'px' }">
              <a @click="editWebform(webform.id)">{{ webform.name }}</a>
            </th>
          </tr>
        </thead>
      </table>

      <table v-if="!webformLoading && !serviceAreaLoading && webformIDs.length === 0">
        <thead>
          <tr>
            <th rowspan="2" class="border-R" ref="tableSAG">Service Area Geofences</th>
            <th :colspan="webforms.length" ref="tableWN">Webform Name</th>
          </tr>
          <tr>
            <th v-for="(webform, index) in webforms" :ref="'tableWF' + index" :id="'tableWF' + index"><a @click="editWebform(webform.id)">{{ webform.name }}</a></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="service in serviceArea">
            <td class="service-area border-R">{{ service.name }}</a></td>
            <td v-for="webform in webforms" class="check-items" :key="webform.id">
              <!-- <i class="fas fa-check-square" v-if="isChecked(service, webform)"></i> -->
              <i class="fas fa-check-circle fa-2x" v-if="isChecked(service, webform)"></i>
              <!-- <i class="far fa-square" v-else></i> -->
            </td>
          </tr>
        </tbody>
      </table>

      <div v-else class="loading">
        <i class="fas fa-spinner fa-spin"></i>
        Getting webform data...
      </div>
    </div>

    <div v-else>
      <div class="cards" v-if="!webformLoading && !serviceAreaLoading && webformIDs.length === 0">
        <div class="webform">
          <div v-for="(webform, index) in webforms" :ref="'tableWF' + index" :id="'tableWF' + index" :key="index">
            <a @click="editWebform(webform.id)">
              <div class="webform-list">
                {{ webform.name }}
              </div>
            </a>
          </div>
        </div>
        <div class="card" v-for="service in serviceArea" :key="service.id">
          <div class="card-header">
            {{service.name}}
          </div>
          <div class="checked-items">
            <div v-for="webform in webforms" class="check-items" :key="webform.id">
                <div v-if="isChecked(service, webform)">
                  <i class="fas fa-check-circle fa-2x"></i> <span class="name">{{webform.name}}</span>
                </div>
            </div>
          </div>
        </div>
      </div>

      <div v-else class="loading">
        <i class="fas fa-spinner fa-spin"></i>
        Getting webform data...
      </div>
    </div>
  </div>
</template>

<script>
import ApiWebform from '@/modules/api/brands/webforms'

export default {
  name: 'webform-list',
  props: ['isMobile'],
  components: {},
  data () {
    return {
      tab: 0,
      webformIDs: [],
      webforms: {},
      webformDataLoading: false,
      sticky: false,
      dimension: {
        tableSAG: 0,
        tableWN: 0,
        webForms: {}
      }
    }
  },
  computed: {
    brands () { return this.$store.state.brands.list },
    serviceArea () { return this.$store.state.brands.serviceArea.list },
    _webforms () { return this.$store.state.brands.webform.list },
    webformLoading () { return this.$store.state.brands.webform.loading },
    serviceAreaLoading () { return this.$store.state.brands.serviceArea.loading },
    _webformRerender () { return this.$store.state.brands.webform.rerender }
  },
  methods: {
    getServiceArea () {
      let self = this
      self.$store.commit('brands/setWebformLoading', true)
      self.$store.commit('brands/seterviceAreaLoading', true)
      ApiWebform.getServiceArea(self, function (res) {
        self.$store.commit('brands/seterviceAreaLoading', false)
      })
    },
    getWebforms () {
      let self = this
      self.$store.commit('brands/setWebformLoading', true)
      ApiWebform.getWebforms(self, function (res) {
        self.$store.commit('brands/setWebformLoading', false)
      })
    },
    getWebformData () {
      let self = this
      if (self.webformDataLoading) { return }

      self.webformDataLoading = true
      ApiWebform.getWebformData(self, self.webformIDs[0], function (res) {
        self.webformDataLoading = false
        if (!res.error) {
          self.webformIDs.shift()
          if (self.webformIDs.length > 0) {
            self.getWebformData()
          } else {
            self.$nextTick(() => { self.getDimensions() })
          }
        }
      })
    },
    editWebform (id) {
      let self = this
      let index = self.webforms.findIndex(x => x.id === id)
      self.$store.commit('brands/setWebformEdit', self.webforms[index])
      setTimeout(function () {
        self.$store.commit('brands/setWebformShow', true)
      }, 300)
    },
    isChecked (service, webform) { return webform.geofencesIDs.indexOf(service.id) > -1 },
    onScroll () {
      if (!this.dimension.tableSAG || !this.dimension.tableWN ||
        Object.keys(this.dimension.webForms).length === 0
      ) {
        this.getDimensions()
        return false
      }

      for (let key in this.dimension.webForms) {
        if (!this.dimension.webForms[key]) {
          this.getDimensions()
          return false
        }
      }

      this.sticky = window.pageYOffset > 101
    },
    getDimensions () {
      let self = this
      if(self.isMobile) {
        return
      }
      self.dimension.tableSAG = self.$refs.tableSAG.clientWidth + 1
      self.dimension.tableWN = self.$refs.tableWN.clientWidth
      self.webforms.forEach(function (webform, index) {
        self.dimension.webForms['tableWF' + index] = self.$refs['tableWF' + index][0].clientWidth
      })
      console.log(self.dimension)
    }
  },
  watch: {
    serviceArea: function (value) { if (value) this.getWebforms() },
    _webforms: function (value) {
      this.webforms = value
      if (value) {
        value.forEach(val => {
          this.webformIDs.push(val.id)
        })
        this.getWebformData()
      }
    },
    _webformRerender: function (value) {
      let self = this
      self.webforms = ''
      self.$nextTick(() => { self.webforms = self.$store.state.brands.webform.list })
    }
  },
  mounted () {
    let self = this
    self.getServiceArea()

    // self.onScroll()
    window.onscroll = function () { self.onScroll() }
  }
}
</script>

<style lang="scss" scoped>
table{
  border-collapse: collapse;
  width: 100%;

  thead{
    color: #8DA0A9;
    font-size: 12px;
    border: 1px solid rgba(0,0,0,0.3);
    background-color: #f5f5f5;

    th{ padding: 5px 10px; }
    .sortable{
      cursor: pointer;
      color: #333;
      text-decoration: underline;

      i{ margin-left: 2px; }
    }
  }

  tbody{
    tr{
      background-color: #fff;
      border: 1px solid rgba(0,0,0,0.3);

      &:hover { background: #e3e7e8!important; }
      &:nth-of-type(even) { background: #fcfcfc; }
      td{
        padding: 10px;
        text-align: center;
        font-size: 12px;
        margin-bottom: 5px;

        &.table-block{
          padding: 30px;
          font-size: 24px;
          color: #777;
          font-weight: 600;
          font-style: italic;

          .fa{ color: #ccc; }
        }
      }
    }
  }

  .border-R{ border-right: 1px solid #ccc; }
  .service-area{
    text-align: left;
    color: #333;
    font-weight: 600;
  }
  .check-items i{
    font-size: 21px;
    color: #0fda4e;
    /* &.fa-check-circle{ color: #0fda4e; }
    &.fa-square{ color: #94b0d0; } */
  }
  a{ cursor: pointer; }
}

.sticky{
    position: fixed;
    top: 0;
    left: 0;
}

.loading{
  padding:40px;
  font-size: 38px;
  text-align: center;
  color: #aaa;
  i{ margin-right: 10px; }
}

.slide-down-enter-active, .slide-down-leave-active { transition: all .3s ease; }
.slide-down-enter, .slide-down-leave-to {
  transform: rotateX(-90deg);
  opacity: 0;
}

@media only screen and (max-width: 430px) {
  .loading{
    font-size: 21px;
  }
  .cards {
    padding-bottom: 100px;

    .webform {
      column-count: 2;
      padding: 15px 20px;

      .webform-list {
        border: 1px solid #ccc;
        padding: 5px 8px;
        background-color: #fff;
        font-weight: 900;
        font-size: 14px;
        margin-bottom: 5px;
      }
    }
    .card {
      border: 1px solid #ccc;
      margin: 0 10px;
      margin-bottom: 15px;
      padding: 8px;
      padding-bottom: 3px;
      border-bottom: 5px solid #aaa9;
      border-radius: 10px;
      font-weight: 700;

      .checked-items {
        column-count: 2;
        .check-items {
          i {
            font-size: 12px;
            color: #0fda4e;
          }
          span {
            font-size: 14px;
            color: #333;
            font-weight: 100;
          }
        }
      }


      > div {
        margin-bottom: 3px;
      }

      .card-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 16px;
        .name {
          font-weight: 900;
        }
        .amount {
          margin-left: 5px;
          font-size: 14px;
        }
        .status {
          text-transform: uppercase;
          font-size: 12px;
          font-weight: 900;
        }
      }

      .title {
        display: flex;
        align-items: center;
      }

      .label {
        font-size: 12px;
        text-transform: uppercase;
        color: #bbb;
        font-weight: 600;
        margin-right: 5px;
      }

      .value {
        margin-right: 10px;
        font-size: 13px;
        font-weight: 900;

        i {
          opacity: 0.3;
        }
      }

      .edit {
        text-align: right;
        margin-bottom: 10px;
        text-transform: uppercase;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Brands/WebformList.vue